import { Box, Stack, TextField } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { Text } from "@src/appV2/redesign/components/Text";
import { type AccountSwitcherUser, type UserDetails } from "../../Shared/AccountSwitcher/types";
import { AccountSwitcherOptionGroupDesktop } from "./AccountSwitcherOptionGroup";

interface AccountSwitcherDropdownAdminDesktopProps {
  workerDetails: UserDetails;
  workplaceDetails: UserDetails;
  onUserClicked: (user: AccountSwitcherUser) => void;
  onAdminClicked: () => void;
  onSearchChanged: (searchTerm: string) => void;
}

export function AccountSwitcherDropdownAdminDesktop(
  props: AccountSwitcherDropdownAdminDesktopProps
) {
  const { workerDetails, workplaceDetails, onUserClicked, onAdminClicked, onSearchChanged } = props;

  return (
    <>
      <Stack padding={2}>
        {/* TODO: replace text field, with redesigned component */}
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Search agents or workplaces..."
          sx={(theme) => ({
            marginBottom: 2,
            "& .MuiOutlinedInput-root": {
              backgroundColor: theme.palette.background?.inverted?.muted,
              color: theme.palette.navbar?.itemContentSelected,
              "& fieldset": {
                borderColor: theme.palette.button?.outline?.inverted?.normal?.borderColor,
              },
              "&:hover fieldset": {
                borderColor: theme.palette.button?.outline?.inverted?.hover?.borderColor,
              },
              "&.Mui-focused fieldset": {
                borderColor: theme.palette.button?.outline?.inverted?.hover?.borderColor,
              },
            },
            "& .MuiOutlinedInput-input": {
              color: theme.palette.navbar?.itemContentSelected,
              "&::placeholder": {
                color: theme.palette.navbar?.itemContent,
                opacity: 1,
              },
            },
          })}
          onChange={(event) => {
            onSearchChanged(event.target.value);
          }}
        />
        <Button fullWidth variant="outlineInverted" onClick={onAdminClicked}>
          Switch To Administrator
        </Button>
      </Stack>
      <Box>
        <Box data-testid="account-switcher-agents" sx={{ marginBottom: 3 }}>
          <Text
            variant="body1"
            sx={(theme) => ({
              color: theme.palette.navbar?.sectionTitle,
            })}
          >
            AGENTS
          </Text>
          <Box>
            <AccountSwitcherOptionGroupDesktop
              userDetails={workerDetails}
              onUserClicked={onUserClicked}
            />
          </Box>
        </Box>
        <Box>
          <Text
            variant="body1"
            sx={(theme) => ({
              color: theme.palette.navbar?.sectionTitle,
            })}
          >
            WORKPLACES
          </Text>
          <Box>
            <AccountSwitcherOptionGroupDesktop
              userDetails={workplaceDetails}
              onUserClicked={onUserClicked}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}
